<template>
    <div>
      <router-link
          class="action"
          :class="{'premium': subscription_plan.premium}"
          :to="{ name: 'purchase.subscription', query: { plan: subscription_plan.id } }"
      >
        <div class="icon"></div>
        <div class="description">
          <template
            v-if="subscription_plan.premium"
          >
            <span>
              <!-- {{ $t('webstars.buttons.premium.title', { currency_symbol: 'U$', amount: subscription_plan.amount }) }} -->
              {{ $t('webstars.buttons.premium.simpleTitle').toUpperCase() }}
            </span>
            <small>
              {{ $t('webstars.buttons.premium.subtitle') }}
            </small>
          </template>
          <template
            v-else
          >
            <span>
              <!-- {{ $t('webstars.buttons.normal.title', { currency_symbol: 'U$', amount: subscription_plan.amount }) }} -->
              {{ $t('webstars.buttons.normal.simpleTitle').toUpperCase() }}
            </span>
            <small>
              {{ $t('webstars.buttons.normal.subtitle') }}
            </small>
          </template>
        </div>
      </router-link>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
      subscription_plan: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
        };
    },
    methods: {
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action{
  display: flex;
  width: 300px;
  height: 50px;
  text-align: center;
  background: #dedfe2;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: 600;
  
  .icon {
    width: 80px;
    height: 50px;
    // background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: var(--img-btn-eye);
    background-color: var(--pallete_main_color);
  }

  .description {
    width: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    span:first-child{
      font-size: .9em;
    }
    
    small {
      font-size: .7em;
    }
  }
  
  &.premium {
    .icon {
      background-image: url("/img/btn/btn-premium.png");
    }
    .description {}
  }
}
</style>
